/**
 * Simple Tabs
 * 
 * @version 1.0.0
 * @license MIT
 * @author Raúl Mortes Illescas <correomortes@gmail.com>
 */

window.addEventListener("DOMContentLoaded", () => {
  const pathname = window.location.pathname;
  const tabsWrappers = document.querySelectorAll(".simple-tabs");
  for (let i = 0; i < tabsWrappers.length; i++) {
    const wrapper = tabsWrappers[i];
    const styleSheet = document.createElement("style");
    wrapper.appendChild(styleSheet);

    const tabsWrapper = document.createElement("div");
    tabsWrapper.classList.add("tabs");
    wrapper.prepend(tabsWrapper);

    const panels = wrapper.querySelectorAll(".panel");
    for (let j = 0; j < panels.length; j++) {
      const panel = panels[j];
      const title = panel.dataset.title;
      const path = panel.dataset.path;

      const randomId = 'st-' + Math.random().toString(36).substring(7);
      const tabRandomId = randomId + "-tab";
      const panelRandomId = randomId + "-panel";

      const radioInput = document.createElement("input");
      radioInput.classList.add("radio");
      radioInput.setAttribute("id", randomId);
      radioInput.setAttribute("name", "group");
      radioInput.setAttribute("type", "radio");
      if (j === 0) { radioInput.setAttribute("checked", true) };
      if (path && path === pathname) {
        const allRadioInputs = wrapper.querySelectorAll(".radio");
        allRadioInputs.forEach((input) => {
          input.removeAttribute("checked");
        });
        radioInput.setAttribute("checked", true);
      }
      wrapper.prepend(radioInput);

      const tab = document.createElement("label");
      tab.classList.add("tab");
      tab.setAttribute("id", tabRandomId);
      tab.setAttribute("for", randomId);
      tab.innerText = title;
      tabsWrapper.appendChild(tab);

      tab.addEventListener("click", () => {
        if (path) {
          window.history.pushState({}, title, path);
        }
      });

      panel.setAttribute("id", panelRandomId);

      styleSheet.sheet.insertRule(`
        #${randomId}:checked~.panels #${panelRandomId} {
          display: block;
        }
      `);

      styleSheet.sheet.insertRule(`
        #${randomId}:checked~.tabs #${tabRandomId} {
          background: #fffffff6;
          color: #000;
          border-bottom: 1px solid #000;
        }
      `);
    }
  }
});